export class AuthConfig {
    register: string;
    login: string;
    refreshToken?: string;
}
